(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomRouteTypeAttributeDeleteController',CustomRouteTypeAttributeDeleteController);

    CustomRouteTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomRouteTypeAttribute'];

    function CustomRouteTypeAttributeDeleteController($uibModalInstance, entity, CustomRouteTypeAttribute) {
        var vm = this;

        vm.customRouteTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomRouteTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
